import {useForm} from 'react-hook-form';
import {useNavigate} from 'react-router-dom';
import {ChangePasswordRequest, changePasswordRequestSchema, ReadUser,} from '@tinct/core-api-models';
import {zodResolver} from '@hookform/resolvers/zod';
import {useChangePassword} from "@tinct/core-api";
import {handleApiError} from "@tinct/web-form";
import {toast} from "sonner";

export const useChangePasswordForm = (user: ReadUser) => {
  const navigate = useNavigate();
  const form = useForm<ChangePasswordRequest>({
    resolver: zodResolver(changePasswordRequestSchema),
    defaultValues: {
      currentPassword: '',
      newPassword: '',
      repeatNewPassword: '',
    },
  });

  const changePassword = useChangePassword({
    // A password change ends every session, this one included (B-237): sign in again with the new one
    onSuccess: () => {
      toast.success("Password changed. Sign in again with your new password.");
      form.reset();
      navigate('/logout');
    },
    onError: (error) => handleApiError(error, form),
  });


  const handleSubmit = form.handleSubmit((data) => {
    changePassword.mutate({
      userId: user.id as string,
      data
    })
  });

  return {form, handleSubmit, isLoading: changePassword.isPending};
};
